'use client';

import { c as _c } from "react/compiler-runtime";
import { createStaticMapsUrl, StaticMap } from '@vis.gl/react-google-maps';
import { useDotEnv } from '@repo/dot-env/client';
import { type RoutePreviewStop } from './route-preview.ts';
import { useRoutePreview } from './use-route-preview.ts';
const DEFAULT_CENTER = {
  lat: 54,
  lng: -2
};
const DEFAULT_ZOOM = 7;
const SINGLE_STOP_ZOOM = 10;
const STATIC_MAP_SIZE = 600;
const STATIC_MAP_SCALE = 2;
const ROUTE_COLOR = '#000000';
const ROUTE_WEIGHT = 8;
const MARKER_SIZE = 'small' as const;
type StaticRouteMapProps = {
  className?: string;
  drops: RoutePreviewStop[];
};
export const StaticRouteMap = t0 => {
  const $ = _c(12);
  const {
    className,
    drops
  } = t0;
  const env = useDotEnv();
  const {
    encodedPaths,
    points
  } = useRoutePreview(drops);
  if (!env.GOOGLE_MAPS_API_KEY) {
    return null;
  }
  let t1;
  if ($[0] !== env.GOOGLE_MAPS_API_KEY) {
    t1 = createStaticMapsUrl({
      apiKey: env.GOOGLE_MAPS_API_KEY,
      center: DEFAULT_CENTER,
      height: STATIC_MAP_SIZE,
      scale: STATIC_MAP_SCALE,
      width: STATIC_MAP_SIZE,
      zoom: DEFAULT_ZOOM
    });
    $[0] = env.GOOGLE_MAPS_API_KEY;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let url = t1;
  if (points.length === 1) {
    let t2;
    if ($[2] !== env.GOOGLE_MAPS_API_KEY || $[3] !== points[0]) {
      t2 = createStaticMapsUrl({
        apiKey: env.GOOGLE_MAPS_API_KEY,
        center: points[0],
        height: STATIC_MAP_SIZE,
        markers: [{
          color: ROUTE_COLOR,
          location: points[0],
          size: MARKER_SIZE
        }],
        scale: STATIC_MAP_SCALE,
        width: STATIC_MAP_SIZE,
        zoom: SINGLE_STOP_ZOOM
      });
      $[2] = env.GOOGLE_MAPS_API_KEY;
      $[3] = points[0];
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    url = t2;
  }
  if (points.length > 1) {
    let t2;
    if ($[5] !== encodedPaths || $[6] !== env.GOOGLE_MAPS_API_KEY || $[7] !== points) {
      t2 = createStaticMapsUrl({
        apiKey: env.GOOGLE_MAPS_API_KEY,
        height: STATIC_MAP_SIZE,
        markers: points.map(_temp),
        paths: encodedPaths.map(_temp2),
        scale: STATIC_MAP_SCALE,
        width: STATIC_MAP_SIZE
      });
      $[5] = encodedPaths;
      $[6] = env.GOOGLE_MAPS_API_KEY;
      $[7] = points;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    url = t2;
  }
  let t2;
  if ($[9] !== className || $[10] !== url) {
    t2 = <StaticMap className={className} url={url} data-sentry-element="StaticMap" data-sentry-component="StaticRouteMap" data-sentry-source-file="static-route-map.tsx" />;
    $[9] = className;
    $[10] = url;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
function _temp(point) {
  return {
    color: ROUTE_COLOR,
    location: point,
    size: MARKER_SIZE
  };
}
function _temp2(encodedPath) {
  return {
    color: ROUTE_COLOR,
    coordinates: `enc:${encodedPath}`,
    weight: ROUTE_WEIGHT
  };
}